<template>
  <Page>
    <div class="flex flex-col gap-4 w-full">
      <ScheduleHeader
        :date="selectedDate"
        :view="view"
        @updateSelectedDate="handleDateChange"
        @updateView="handleViewChange"
      />
      <div v-if="view === 'timeline'">
        <MobileTimeline
          v-if="mobileView"
          :date="selectedDate"
          @date-navigated="handleDateChange"
        />
        <Timeline v-else :date="selectedDate" @date-navigated="handleDateChange" />
      </div>
      <div v-else>Capacity View</div>
    </div>
  </Page>
</template>

<script setup lang="ts">
import moment from "moment-timezone";
import { onBeforeMount, onBeforeUnmount, onMounted, ref } from "vue";
import { syncStartParam } from "@/lib/scheduleStartParam";
import { getQueryVariables } from "@/lib/url";

import Page from "@/components/Page.vue";
import { breakpoints } from "@/mixins";
import MobileTimeline from "./MobileTimeline.vue";
import ScheduleHeader from "./ScheduleHeader.vue";
import Timeline from "./Timeline.vue";

const view = ref<"timeline" | "capacity">("timeline");
const selectedDate = ref(new Date());
const mobileView = ref(breakpoints().sm);

const handleDateChange = (date: Date | number | string) => {
  selectedDate.value = moment(date).toDate();
  // The URL is the source of truth for the board date — sync it at nav time
  syncStartParam(selectedDate.value);
};

const handleViewChange = (_view: "timeline" | "capacity") => {
  view.value = _view;
};

onBeforeMount(() => {
  const { start } = getQueryVariables();
  if (start) {
    selectedDate.value = moment(start, "YYYY-MM-DD").hours(12).toDate();
  }
});

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
const handleResize = () => {
  mobileView.value = breakpoints().sm;
};
</script>
